const openKodifChat = () => {
  const iframe = document.getElementById('kodif-chat-widget');
  if (!iframe?.contentWindow) return false;

  iframe.contentWindow.postMessage(
    { type: 'toggle-expanded', isExpanded: true },
    '*'
  );
  return true;
};

const clickWingmanLauncher = () => {
  const wingmanHost = document.querySelector('wingman-widget');
  const wingmanWrapper =
    wingmanHost?.shadowRoot?.getElementById('wingman-wrapper') ??
    document.getElementById('wingman-wrapper');

  const wingmanBtn = wingmanWrapper?.querySelector('button');
  if (!wingmanBtn) return false;

  wingmanBtn.click();
  return true;
};

document.addEventListener('click', (e) => {
  const trigger = e.target?.closest('.open-kodif-chat');
  if (!trigger) return;
  if (openKodifChat()) return;

  if (!clickWingmanLauncher()) return;

  const observer = new MutationObserver(() => {
    if (openKodifChat()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 10000);
});